import React, { useEffect, useState } from "react";
import MainDashboardLayout from "../../../../Layout/MainDashboardLayout";
import GRISidebar from "../../../../Layout/GRISidebar";
import styles from "../../../../styles/gri/general.module.css";
import InputField from "../../../../Components/Masters/InputField";
import { Box, Button } from "@mui/material";
import EastIcon from "@mui/icons-material/East";
import { get, put } from "../../../../utils/api";
import { useNavigate, useParams } from "react-router-dom";
import { validateNumber } from "../../../../utils/validateFields";
import MessagePopup from "../../../../Components/Masters/MessagePopup";

import ReviewBox from "../../../../Components/Common/ReviewBox";
import { currentYear } from "../../../../utils/generateYearRanges";

const GRI202_1 = ({ hide }) => {
  const questionData = [
    {
      fieldName: "entryLevelWageRatioByGender",
      title:
        "a. What is the ratio of entry-level wages by gender at significant locations of operation to the applicable minimum wage for employees compensated based on wages subject to minimum wage rules?",
      type: "text",
      placeholder: "Enter Text",
      letter: "a.",
    },
    {
      fieldName: "stepsToEnsureAboveMinimumWage",
      title:
        "b. Could you provide details on the steps taken to ensure that other workers (excluding employees) involved in the organization’s activities and compensated based on wages subject to minimum wage rules are paid above the minimum wage?",
      type: "text",
      placeholder: "Enter Text",
      letter: "b.",
    },
    {
      fieldName: "locationsWithNoOrVariableMinimumWage",
      title:
        "c. Are there any significant locations of operation where a local minimum wage is absent or variable, categorized by gender? If different minimum wages are applicable, please specify which minimum wage is being utilized.",
      type: "text",
      placeholder: "Enter Text",
      letter: "c.",
    },
    {
      fieldName: "significantLocationsDefinition",
      title:
        "d. How do you define 'significant locations of operation' within your organization's context?",
      type: "text",
      placeholder: "Enter Text",
      letter: "d.",
    },
  ];

  const navigate = useNavigate();
  const { id } = useParams();
  const [errors, setErrors] = useState({});
  const [disabled, setDisabled] = useState(false);
  const [data, setData] = useState({});
  const [formData, setFormData] = useState({});
  const [snackOpen, setsnackOpen] = useState({
    open: false,
    message: "",
    severity: "",
  });
  const [griReview, setGriReview] = useState(() => JSON.parse(localStorage.getItem("griReview")));

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    const handleStorage = () => {
      setGriReview(JSON.parse(localStorage.getItem("griReview")));
    };
    window.addEventListener("storage", handleStorage);
    return () => window.removeEventListener("storage", handleStorage);
  }, []);

  useEffect(() => {
    setGriReview(JSON.parse(localStorage.getItem("griReview")));
  }, []);

  const fetchData = async () => {
    try {
      const res = await get(`/gri/get?Id=${id}&type=GRI200`);
      const res1 = res?.data?.data?.GRI200?.entryLevelWageRatioByGender;
      if (res?.data?.data?.year ? res?.data?.data?.year < currentYear -1 : false) setDisabled(true);
      setData(res1);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    setFormData({
      entryLevelWageRatioByGender: data?.entryLevelWageRatioByGender || "",
      stepsToEnsureAboveMinimumWage: data?.stepsToEnsureAboveMinimumWage || "",
      locationsWithNoOrVariableMinimumWage:
        data?.locationsWithNoOrVariableMinimumWage || "",
      significantLocationsDefinition:
        data?.significantLocationsDefinition || "",
    });
  }, [data]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "distance" && !validateNumber(value)) return;
    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const validateForm = () => {
    const newErrors = {};
    questionData.forEach((el) => {
      if (!formData[el.fieldName] || formData[el.fieldName].trim() === "") {
        newErrors[el.fieldName] = "Required";
      }
    });

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async () => {
    if (!disabled) {
      // if (!validateForm()) return;
      let transformedData2 = {
        entryLevelWageRatioByGender: formData,
        type: "GRI200",
        submitted202_1: true,
      };
      try {
        const res = await put(`/gri/update?Id=${id}`, transformedData2);
        setsnackOpen({
          open: true,
          message: res.data.message,
          severity: "success",
        });
        navigate(`/gri/economic-performance/202-2/${id}`);
      } catch (error) {
        console.log(error);
        setsnackOpen({
          open: true,
          message: error.data.message,
          severity: "error",
        });
      }
    } else {
      navigate(`/gri/economic-performance/202-2/${id}`);
    }
  };

  const renderContent = ({ hide }) => (
    <>
      <MessagePopup {...{ snackOpen, setsnackOpen }} />{" "}
      {/* <Box sx={{ display: "flex" }}> */}
     {!hide && <p className={styles.section_heading} style={{marginBottom: hide ? "-1rem" : "0"}}>202 : Market Presence 2016</p>}
      <p className={styles.main_heading}>
        202-1 : Ratios of standard entry level wage by gender compared to local
        minimum wage
      </p>
      {/* </Box> */}
      {/* a */}
      {questionData.map((el) => (
        <Box >
          <Box sx={{ display: "flex", gap: 1 }}>
            {/* <p className={styles.ques_heading}>{el.letter}</p> */}
            <p className={styles.ques_heading} style={{textIndent:"-1.1rem",}}>{el.title}</p>
          </Box>
          <Box sx={{ ml: 2 }}>
            <InputField
              placeholder={"Enter Text"}
              fieldName={el.fieldName}
              value={formData?.[el.fieldName]}
              handleChange={handleChange}
              mt="-5px"
              errors={errors[el.fieldName] && true}
              disabled={disabled}
            />
            <p
              color="error"
              variant="caption"
              style={{
                lineHeight: "1.2",
                margin: "2px 0",
                marginTop: "5px",
                color: "#d34040",
                fontSize: "10px",
                fontStyle: "italic",
              }}
            >
              {errors[el.fieldName]}
            </p>
          </Box>
        </Box>
      ))}
    </>
  );

  return (
    <>
      {!hide ? (
        <MainDashboardLayout sidebar={<GRISidebar />}>
          {renderContent({ hide })}

          <>
            {!griReview ? (
              <Box sx={{ ml: "1rem", width: "98%" }}>
                <ReviewBox url={"/gri"} handleSubmit={handleSubmit} />
              </Box>
            ) : (
              <Box textAlign="right" sx={{ mt: 3 }}>
                <Button
                  onClick={handleSubmit}
                  variant="contained"
                  sx={{
                    bgcolor: "#1C486B",
                    textTransform: "none",
                    mt: 3,
                    mb: 5,
                  }}
                >
                  Save & Continue <EastIcon sx={{ ml: 2 }} />
                </Button>
              </Box>
            )}
          </>
        </MainDashboardLayout>
      ) : (
        renderContent({ hide })
      )}
    </>
  );
};

export default GRI202_1;
